export namespace TestObjectsActions{
    export class SetAllTestObjects {
        static readonly type = '[TestObjects] SetAllTestObjects';
        constructor() {}
    }
}